// SCR-050 — Cơ quan & địa bàn (M24, ACT-09). Thay FeaturePlaceholder cũ tại route /administration.
// RBAC backend là điểm enforce; ở đây non-admin chỉ không thấy UI và section không được mount
// → zero API call từ section (rule AC-15/AC-09).
// Quyết định tab (handoff docs/07-uiux §3): lazy-mount theo lần kích hoạt đầu và GIỮ MOUNT
// (ẩn bằng display) khi chuyển tab — không mất selection/state, không double-fetch khi quay lại.

import { useState } from "react";
import { Result, Segmented, Skeleton } from "antd";
import { useActorContext } from "../../auth/ActorContext";
import { PageHeading } from "../../components/PageHeading";
import { OrganizationAdminSection } from "./OrganizationAdminSection";
import { AdministrativeAreaAdminSection } from "./AdministrativeAreaAdminSection";

const NCC_ADMIN_ROLE = "NCC_ADMIN";

export function AdministrationPage() {
  const state = useActorContext();
  const [tab, setTab] = useState<"co-quan" | "dia-ban">("co-quan");
  const [areaActivated, setAreaActivated] = useState(false);

  if (state.status === "loading") {
    return (
      <div role="status" aria-label="Đang tải trang quản trị">
        <Skeleton active paragraph={{ rows: 8 }} />
      </div>
    );
  }

  const isAdmin =
    (state.status === "ready" || state.status === "refreshing" || state.status === "stale") &&
    state.actor.grants.some((grant) => grant.roleCode === NCC_ADMIN_ROLE);

  if (!isAdmin) {
    return (
      <Result
        status="403"
        title="Bạn không có quyền truy cập quản trị"
        subTitle="Màn hình này chỉ dành cho vai trò NCC_ADMIN. Liên hệ quản trị viên hệ thống để được cấp quyền."
      />
    );
  }

  return (
    <>
      <PageHeading
        title="Cơ quan & địa bàn"
        description="Quản lý cây cơ quan và địa bàn theo thời gian hiệu lực: tạo mới, đổi tên, chuyển quản lý, sáp nhập, đóng/mở. Không có thao tác xóa vật lý."
      />
      <Segmented
        aria-label="Chọn phạm vi quản trị"
        options={[
          { label: "Cơ quan", value: "co-quan" },
          { label: "Địa bàn", value: "dia-ban" },
        ]}
        value={tab}
        onChange={(value) => {
          setTab(value as "co-quan" | "dia-ban");
          if (value === "dia-ban") setAreaActivated(true);
        }}
      />
      <div style={{ marginTop: "var(--ncc-spacing-lg)", display: tab === "co-quan" ? "block" : "none" }}>
        <OrganizationAdminSection />
      </div>
      {areaActivated && (
        <div style={{ marginTop: "var(--ncc-spacing-lg)", display: tab === "dia-ban" ? "block" : "none" }}>
          <AdministrativeAreaAdminSection />
        </div>
      )}
    </>
  );
}
